import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify';
import './plugins/vuetify';
import './plugins/chartist';
import 'vuetify/dist/vuetify.min.css';
import router from './router';
import store from './store';
import VeeValidate from 'vee-validate';
import {createProvider} from './vue-apollo'
import i18n from './i18n'
import {SchedulePlugin} from '@syncfusion/ej2-vue-schedule'
import { loadCldr } from '@syncfusion/ej2-base';

loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require('cldr-data/main/pl/ca-gregorian.json'),
    require('cldr-data/main/pl/numbers.json'),
    require('cldr-data/main/pl/timeZoneNames.json'));
Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(SchedulePlugin);

new Vue({
    router,
    store,
    vuetify,
    // apolloProvider: createProvider(),
    i18n,
    render: h => h(App)
}).$mount('#app');

